<template>
  <div class="input-group-prepend equipment-selector">
    <EquipmentSelectionDropdown
      v-if="isCheckedInTrim"
      :selected-in-trim="isCheckedInTrim"
      :selected="!isDisabled"
      @enable="enable()"
      @disable="disable()"
    />
    <EquipmentSelectionCheckbox v-else :selected="isChecked" @change="toggle()" />

    <div class="equipment-name-container" @click="toggle()">
      <div class="equipment-name-title">{{ value.name }}</div>
      <Popper
        v-if="isCheckedInTrim"
        class="popper--secondary equipment-name-tag"
        placement="right"
        hover
        offset-distance="4"
        arrow
        :content="$t('components/equipments.tooltips.see_floorplan')"
      >
        <div class="d-flex">
          <a :href="trimEquipmentRoute" target="_blank">
            {{ __('stock_equipment.floorplan') }}
          </a>
        </div>
      </Popper>
    </div>
  </div>
</template>

<script>
import EquipmentSelectionDropdown from '@components/equipment/EquipmentSelectionDropdown.vue'
import EquipmentSelectionCheckbox from '@components/equipment/EquipmentSelectionCheckbox.vue'

export default {
  name: 'EquipmentSelector',
  components: { EquipmentSelectionDropdown, EquipmentSelectionCheckbox },
  props: {
    group: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default() {
        return {
          isSelected: false,
          isDisabled: false,
          isSelectedInTrim: false
        }
      }
    },
    trimEquipmentRoute: {
      type: String,
      default: '#'
    }
  },
  emits: ['change'],
  computed: {
    isChecked() {
      return this.value.isSelected
    },
    isDisabled() {
      return this.value.isDisabled
    },
    isCheckedInTrim() {
      return this.value.isSelectedInTrim
    }
  },
  methods: {
    disable() {
      if (this.isDisabled) {
        return
      }

      let equipment = Object.assign({}, this.value)
      equipment.isDisabled = true
      equipment.isImportant = false
      this.$emit('change', equipment)
    },
    enable() {
      if (!this.isDisabled) {
        return
      }

      let equipment = Object.assign({}, this.value)
      equipment.isDisabled = false
      this.$emit('change', equipment)
    },
    toggle() {
      let equipment = Object.assign({}, this.value)
      equipment.isSelected = !equipment.isSelected

      if (!equipment.isSelected) {
        equipment.isImportant = false
      }

      this.$emit('change', equipment)
    }
  }
}
</script>

<style scoped>
.equipment-selector:hover {
  cursor: pointer;
}
</style>
